// 22.01.19 - This subform has full typings.
import {
    reduxForm,
    FormSection,
    change,
    // InjectedFormProps
} from "redux-form";
import * as React from "react";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import {
    // CheckBoxField,
    DateField,
    dateToTimestamp,
    FlexGridItem,
    FlexTextField,
    // SelectField,
    // parseNumber,
    timestampToDate,
    validEmail,
    validDate,
    HideForRoles,
    DisableForRoles,
    validPhoneNo,
    maxLength50,
    maxLength100,
    maxLength200,
    TextArea,
} from "./form_utility";
import { IRootState } from "src/reducers";
// import { IHomeState } from "src/reducers/home";
// import { IDetailState } from "src/reducers/detail";
import FormSelect from "../common/form/controls/select";
import {
    actionSaveAttachmentData,
    actionDownloadAttachment,
    actionDeleteAttachment,
} from "src/actions/detail";
import AttachmentContainer from "src/components/common/attachment-container";
import {
    FORM_TYPE_SHIPMENT_INVENTORY,
    FORM_ERROR_MESSAGE,
} from "src/constants/data.js";
import { UserRoles, CaseType, ClaimStatus } from "src/constants/api";
import { getStringAfterSubstring, getStringBeforeSubstring } from "../../utils";
import { openToaster, closeToaster } from "src/actions/common";

class ShipmentInventoryFormComponent extends React.Component<any, any> {
    public componentWillUnmount() {
        const { closeToaster } = this.props;
        closeToaster();
    }

    public render() {
        const {
            handleSubmit,
            grantTypes,
            saveAttachmentData,
            deleteAttachment,
            downloadAttachment,
            attachmentData,
            uniqueId,
            isNewCase,
            submitFailed,
            invalid,
            openToaster,
            closeToaster,
            isToasterVisible,
        } = this.props;
        const disableForm = this.disableForm();

        if (submitFailed && invalid) {
            openToaster(FORM_ERROR_MESSAGE, false);
        } else if (!invalid && isToasterVisible) {
            closeToaster();
        }
        return (
            <form
                onSubmit={handleSubmit}
            //  className={`${disableForm ? "disableForm" : ""}`}
            >
                <FormSection name="shipments[0]">
                    <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
                        {/* <FlexGridItem xs={12}> */}
                        {/* This will be a header with the Cases shipment no from Main Form */}
                        {/* <p>Shipment No: </p> */}
                        {/* </FlexGridItem> */}
                        <FlexGridItem xs={6}>
                            <FlexTextField
                                name="wbsno"
                                label="WBS No"
                                disabled={disableForm}
                                validate={[maxLength50]}
                            />
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <FlexTextField
                                name="grantNo"
                                label="Grant No"
                                disabled={disableForm}
                                validate={[maxLength50]}
                            />
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DateField
                                name="grantExpiry"
                                label="Grant Expiry"
                                format={timestampToDate}
                                normalize={dateToTimestamp}
                                validate={validDate}
                                disabled={disableForm}
                            />
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            {/* <SelectField
                  name="grantType"
                  label="Grant Type"
                  parse={parseNumber}
                >
                  <option value={undefined} />
                  {grantTypes &&
                    Array.from(grantTypes.entries()).map(([id, x]) => (
                      <option key={id} value={Number(id)}>
                        {x.name}
                      </option>
                    ))}
                </SelectField> */}
                            <FormSelect
                                name="grantType"
                                label="Grant Type"
                                data={grantTypes}
                                disabled={disableForm}
                            />
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[
                                        UserRoles.FMC,
                                        UserRoles.QMU,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                    isnewcase={isNewCase}
                                    disabledField={disableForm}
                                >
                                    <FlexTextField
                                        name="nameOfThirdParty"
                                        label="Name of Third Party"
                                        validate={[maxLength100]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>

                        <FlexGridItem xs={6}>
                            {/* <div className="cb-form-container">
                  <CheckBoxField name="recovery" label="Recovery" />
                </div> */}
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="surveyorDetailsCompanyName"
                                        label="Surveyor details: company name"
                                        validate={[maxLength100]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="contactPerson"
                                        label="Contact person"
                                        validate={[maxLength100]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="sdaddress"
                                        label="Address"
                                        validate={[maxLength200]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="email"
                                        label="Email"
                                        validate={[validEmail, maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="telephone"
                                        label="Telephone"
                                        validate={[validPhoneNo, maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC, UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="brokerReference"
                                        label="Broker reference"
                                        validate={[maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC, UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <DateField
                                        name="settlementAgreed"
                                        label="Settlement agreed"
                                        format={timestampToDate}
                                        normalize={dateToTimestamp}
                                        validate={validDate}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="sdsettlementDocumentNo"
                                        label="SD Settlement document No"
                                        validate={[maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC, UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="amountOfRecoveryObtained"
                                        label="Amount of recovery obtained"
                                        validate={[maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[UserRoles.FMC, UserRoles.UNICEF, UserRoles.Partner]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="claimDesignation"
                                        label="Claim designation"
                                        validate={[maxLength200]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC, UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <DateField
                                        name="presentedForSettlement"
                                        label="Presented for settlement"
                                        format={timestampToDate}
                                        normalize={dateToTimestamp}
                                        validate={validDate}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles roles={[UserRoles.UNICEF, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC, UserRoles.QMU]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <DateField
                                        name="claimClosed"
                                        label="Claim closed"
                                        format={timestampToDate}
                                        normalize={dateToTimestamp}
                                        validate={validDate}
                                        onChange={this.changeClaimClosed}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={12}>
                            <TextArea
                                name="shipmentInventoryComments"
                                label="Comments"
                                disabled={disableForm}
                            />
                        </FlexGridItem>
                        <AttachmentContainer
                            label="Attachments"
                            uniqueId={uniqueId}
                            onSave={saveAttachmentData}
                            attachment={attachmentData}
                            download={downloadAttachment}
                            remove={deleteAttachment}
                            type={FORM_TYPE_SHIPMENT_INVENTORY}
                            disabled={disableForm}
                            {...this.props}
                        />
                    </Grid>
                </FormSection>
            </form>
        );
    }
    // const ShipmentInventoryFormComponent = (props: ShipmentInventoryFormProps) => {

    private disableForm = () => {
        const {
            caseData,
            currentRoleId,
            allowEdit,
            isNewCase,
            mainForm,
            isLockForEdit,
            currentUsername,
        } = this.props;
        let disableForm = false;
        const formValues = mainForm.mainForm.values;
        if (!allowEdit) {
            disableForm = true;
        } else if (!isNewCase && caseData) {
            if (currentRoleId === UserRoles.QMU) {
                disableForm = true;
            } else if (
                currentRoleId === UserRoles.INS &&
                formValues.caseType === CaseType.Complaint
            ) {
                disableForm = true;
            } else if (currentRoleId === UserRoles.UNICEF && isLockForEdit) {
                disableForm = true;
            } else if (
                currentRoleId === UserRoles.Solution_Owner ||
                currentRoleId === UserRoles.Solution_Team
            ) {
                // Get username who created the case
                let createdBy = mainForm.mainForm.values.createdBy;
                createdBy = getStringAfterSubstring(createdBy, "(");
                createdBy = getStringBeforeSubstring(createdBy, ")").trim();

                if (currentUsername !== createdBy || isLockForEdit) {
                    disableForm = true;
                }
            }
        }

        return disableForm;
    };

    private changeClaimClosed = (event: any) => {
        const { mainForm, dispatch } = this.props;
        const formValues = mainForm.mainForm.values;
        if (
            event.target.value &&
            formValues.caseType &&
            (formValues.caseType === CaseType.ComplaintClaim ||
                formValues.caseType === CaseType.Claim)
        ) {
            // Change the value of claim status to closed
            dispatch(change("mainForm", "claimStatus", ClaimStatus.Closed));
        }
    };
}

// Needed since we need grant types from the state.
function mapStateToProps(state: IRootState) {
    return {
        grantTypes: state.detail.grantTypes,
        attachmentData: state.detail.attachmentDataShipmentInventory,
        caseData: state.detail.caseData,
        allowEdit: state.detail.allowEdit,
        mainForm: state.form,
        currentUser: state.home.currentUser,
        currentUsername: state.detail.currentUsername,
        isLockForEdit: state.detail.isLockForEdit,
        isToasterVisible: state.common.isToasterVisible,
    };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        saveAttachmentData: (
            file: any,
            uploadedBy: any,
            uniqueId: any,
            prevAttachmentData: any,
            type: string
        ) =>
            dispatch(
                actionSaveAttachmentData(
                    file,
                    uploadedBy,
                    uniqueId,
                    prevAttachmentData,
                    type
                )
            ),
        downloadAttachment: (fileId: any) =>
            dispatch(actionDownloadAttachment(fileId)),
        deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
            dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
        openToaster: (message: string, success: boolean) =>
            dispatch(openToaster(message, success)),
        closeToaster: () => dispatch(closeToaster()),
    };
};

// mainForm is the name of the form object for the Redux form state store.
// enableReinitialize enables changes to initial data to render.
// keepDirtyOnReinitialize enables to keep edited data on reinitialize.
// destroyOnUnmount enables that data is kept when changing tabs.
const ShipmentInventoryForm = reduxForm({
    form: "mainForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false,
    // @ts-ignore
})(ShipmentInventoryFormComponent);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShipmentInventoryForm);
